import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var FolderOpen = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { fill: "none", d: "M5.081 11.606A.999.999 0 0 1 6 11h12V8H9.655L7.1 6H4v8.129l1.081-2.523z", key: "k0" }),
        React.createElement("path", { d: "M2.165 19.551c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21 11h-1V8c0-1.103-.897-2-2-2h-7.655L7.789 4H4c-1.103 0-2 .897-2 2v13h.007a1 1 0 0 0 .158.551zM7.1 6l2.556 2H18v3H6c-.4 0-.762.238-.919.606L4 14.129V6h3.1z", key: "k1" })));
});
FolderOpen.displayName = 'FolderOpen';
export var FolderOpenDimensions = { height: 24, width: 24 };
